var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPersonBreastfeeding, faTrashCan, } from "@fortawesome/pro-regular-svg-icons";
import { LoaderImage } from "@/utils/loader";
import { useGetModuleListQuery, useDeleteRecordsMutation } from "@/store/api";
import toast from "react-hot-toast";
export var MessageDisplay = function (_a) {
    var parentId = _a.parentId;
    var defaultRules = [
        {
            field: "deleted",
            operator: "eq",
            value: 0,
        },
        {
            field: "related_id",
            operator: "eq",
            value: parentId,
        },
    ];
    var _b = useState(defaultRules), rules = _b[0], setRules = _b[1];
    var whereRule = [
        {
            operator: "and",
            rules: rules,
        },
    ];
    var _c = useState([
        {
            name: "date_entered",
            direction: "ascending",
        },
    ]), sortedParams = _c[0], setSortedParams = _c[1];
    // Get corresponding reply message
    var _d = useGetModuleListQuery({
        table: "SugarFeed",
        params: {
            sorted: sortedParams,
            where: whereRule,
            count: false,
        },
    }), replyResponse = _d.data, isLoading = _d.isLoading, isSuccess = _d.isSuccess, refetch = _d.refetch;
    var _e = useState([]), messages = _e[0], setReplyMessage = _e[1];
    var _f = useState(false), onLoading = _f[0], setLoadingMode = _f[1];
    var responses = useMemo(function () {
        var _a;
        var recordData = ((_a = replyResponse === null || replyResponse === void 0 ? void 0 : replyResponse.data) === null || _a === void 0 ? void 0 : _a.records) || [];
        setReplyMessage(recordData);
    }, [replyResponse]);
    var deleteRecordsMutation = useDeleteRecordsMutation()[0];
    var deleteMessage = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoadingMode(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, deleteRecordsMutation({
                            moduleName: "SugarFeed",
                            body: { recordId: id },
                        }).unwrap()];
                case 2:
                    result = _a.sent();
                    toast.success("Enregistrements supprimés");
                    setLoadingMode(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setLoadingMode(false);
                    toast.success("Une erreur est survenue lors de la suppression");
                    console.log("ERREUR DE SUPPRESSION ", error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "border-solid border-l-4 ml-2" }, { children: [onLoading && _jsx(LoaderImage, {}), messages &&
                    messages.length > 0 &&
                    isSuccess &&
                    Object.values(messages).map(function (message, index) { return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "flex flex-row my-2 ml-3" }, { children: [_jsx("div", __assign({ className: "w-11/12" }, { children: _jsxs("span", __assign({ className: "font-medium" }, { children: [_jsx(FontAwesomeIcon, { icon: faPersonBreastfeeding, className: "pr-2" }), message === null || message === void 0 ? void 0 : message.created_by_name, " ", _jsx("span", __assign({ className: "font-light" }, { children: message === null || message === void 0 ? void 0 : message.name }))] })) })), _jsx("div", __assign({ className: "flex w-1/12 justify-end" }, { children: _jsx("span", __assign({ onClick: function () {
                                            deleteMessage(message === null || message === void 0 ? void 0 : message.id);
                                        } }, { children: _jsx(FontAwesomeIcon, { icon: faTrashCan, className: "text-red-400 hover:text-gray-400" }) })) }))] })) })); })] })) }));
};
